import React from 'react';
import { TranslateFunction } from 'react-utilities';

function Epilogue({ translate }: { translate: TranslateFunction }): React.ReactElement {
  return <React.Fragment />;
}
export default Epilogue;
